// Public runtime config the SPA reads before login (served by the API at /api/config).
import { API_BASE } from './apiBase';

export interface PublicConfig {
  /** Whether the public sign-up endpoint accepts new accounts. */
  registrationEnabled: boolean;
}

/**
 * Fetch the API's public config. On any failure we fall back to "registration
 * enabled" so the login screen never breaks — the API still enforces the real
 * block server-side, so an optimistic fallback can't bypass it.
 */
export async function fetchPublicConfig(): Promise<PublicConfig> {
  try {
    const res = await fetch(`${API_BASE}/api/config`, { credentials: 'include' });
    if (!res.ok) return { registrationEnabled: true };
    const data = (await res.json()) as Partial<PublicConfig>;
    return { registrationEnabled: data.registrationEnabled !== false };
  } catch {
    return { registrationEnabled: true };
  }
}
